export default { sha: '6d5b024dfeebdd245f8d09a4440d11550fde148a', buildNumber: 'undefined' }
